import api from './BaseApi';

export const getDynamicFields = async (params) => {
    try {
        const response = await api.get('/admin/poi/global-dynamic-fields', { params });
        return response.data;
    } catch (error) {
        console.error('Get dynamic fields error:', error);
        throw error;
    }
};

export const getDynamicFieldById = async (id) => {
    try {
        const response = await api.get(`/admin/poi/global-dynamic-fields/${id}`);
        return response.data;
    } catch (error) {
        console.error('Get dynamic field error:', error);
        throw error;
    }
};

export const createDynamicField = async (payload) => {
    try {
        const response = await api.post('/admin/poi/global-dynamic-fields', payload);
        return response.data;
    } catch (error) {
        console.error('Create dynamic field error:', error);
        throw error;
    }
};

export const updateDynamicField = async (id, payload) => {
    try {
        const response = await api.put(`/admin/poi/global-dynamic-fields/${id}`, payload);
        return response.data;
    } catch (error) {
        console.error('Update dynamic field error:', error);
        throw error;
    }
};

export const deleteDynamicField = async (id) => {
    try {
        const response = await api.delete(`/admin/poi/global-dynamic-fields/${id}`);
        return response.data;
    } catch (error) {
        console.error('Delete dynamic field error:', error);
        throw error;
    }
};

export const addDynamicFieldOption = async (fieldId, payload) => {
    try {
        const response = await api.post(`/admin/poi/global-dynamic-fields/${fieldId}/options`, payload);
        return response.data;
    } catch (error) {
        console.error('Add dynamic field option error:', error);
        throw error;
    }
};

export const updateDynamicFieldOption = async (optionId, payload) => {
    try {
        const response = await api.put(`/admin/poi/global-dynamic-fields/options/${optionId}`, payload);
        return response.data;
    } catch (error) {
        console.error('Update dynamic field option error:', error);
        throw error;
    }
};

export const deleteDynamicFieldOption = async (optionId) => {
    try {
        const response = await api.delete(`/admin/poi/global-dynamic-fields/options/${optionId}`);
        return response.data;
    } catch (error) {
        console.error('Delete dynamic field option error:', error);
        throw error;
    }
};
